import Category from "./Category";

export default class Movie {
    file?: Category;
    startTime?: number;
    stopTime?: number;

    constructor(start?: number, stop?: number, file?: Category) {
        this.file = file;
        this.startTime = start;
        this.stopTime = stop;
    }
}